import React from 'react';
import logo_unity from '../assets/images/Medsim204.png';
import { Link } from 'react-router-dom'; // Certifique-se de que esta importação está presente


const Unity = () => {
    return (
        <section className="unity py-5" id="unidades-moveis">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-6 pb-3 pb-lg-0">
                        <div className="col-12 col-lg-11 pt-lg-5 pt-0 title">Unidades Móveis de Saúde <span>personalizadas</span> para o seu <span>evento</span> ou <span>empresa</span></div>
                        <div className="py-3 col-12 col-lg-9 subtitle">Leve o atendimento médico diretamente ao seu público com estruturas móveis de alta qualidade e profissionais qualificados.</div>
                        <div className="col-12 col-lg-7 pt-2 button">
                            <Link to="/solicitar-proposta" className="btn btn-warning text-uppercase d-block py-3">
                                <strong><i className="fa-solid fa-arrow-right-long"></i> solicite uma proposta</strong>
                            </Link>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 pt-lg-5 pt-0">
                        <img src={logo_unity} className="img img-fluid rounded-5" alt="Seção unidades móveis de saúde" />
                    </div>
                </div>
            </div>
            <div>

            </div>
        </section>
    );
};

export default Unity;